import { withJWTClient } from "../connectClient";

import {
  ListSeedsResponseSchema,
  SeedMessageSchema,
  type CreativesphereSeedType,
  type ListSeedsResponse,
  type SeedMessage,
  type SeedWriteBody,
} from "@/types/creativesphere";

const API_BASE_URL: string = import.meta.env.VITE_CREATIVESPHERE_API_URL || "";

export async function listSeeds(
  siteId: string,
  seedType: CreativesphereSeedType,
): Promise<ListSeedsResponse> {
  const response = await withJWTClient((client) =>
    client.get<unknown>(`${API_BASE_URL}/v1/${siteId}/seeds`, {
      params: { seed_type: seedType },
    }),
  );
  return ListSeedsResponseSchema.parse(response.data);
}

/**
 * GET /v1/seed-presets — the global preset library. NOT site-scoped; the bearer
 * is still attached. Optional `seedType` narrows to one type; omitted → all.
 */
export async function listSeedPresets(
  seedType?: CreativesphereSeedType,
): Promise<ListSeedsResponse> {
  const response = await withJWTClient((client) =>
    client.get<unknown>(`${API_BASE_URL}/v1/seed-presets`, {
      params: seedType ? { seed_type: seedType } : undefined,
    }),
  );
  return ListSeedsResponseSchema.parse(response.data);
}

export async function getSeed(
  siteId: string,
  slug: string,
): Promise<SeedMessage> {
  const response = await withJWTClient((client) =>
    client.get<unknown>(`${API_BASE_URL}/v1/${siteId}/seeds/${slug}`),
  );
  return SeedMessageSchema.parse(response.data);
}

export async function createSeed(
  siteId: string,
  body: SeedWriteBody,
): Promise<SeedMessage> {
  const response = await withJWTClient((client) =>
    client.post<unknown>(`${API_BASE_URL}/v1/${siteId}/seeds`, body),
  );
  return SeedMessageSchema.parse(response.data);
}

export async function updateSeed(
  siteId: string,
  slug: string,
  body: Partial<SeedWriteBody>,
): Promise<SeedMessage> {
  const response = await withJWTClient((client) =>
    client.patch<unknown>(`${API_BASE_URL}/v1/${siteId}/seeds/${slug}`, body),
  );
  return SeedMessageSchema.parse(response.data);
}

export async function deleteSeed(siteId: string, slug: string): Promise<void> {
  await withJWTClient((client) =>
    client.delete(`${API_BASE_URL}/v1/${siteId}/seeds/${slug}`),
  );
}
